import { useState } from 'react';
import { List, Article, Image as ImageIcon } from '@phosphor-icons/react';
import { HeaderNavManagement } from './layout/HeaderNavManagement';
import { BannersManagement } from './layout/BannersManagement';
import { FooterManagement } from './FooterManagement';

const TABS = [
  { key: 'header', label: 'Header', icon: List, description: 'Top navigation links' },
  { key: 'footer', label: 'Footer', icon: Article, description: 'Site-wide footer sections' },
  { key: 'banners', label: 'Banners', icon: ImageIcon, description: 'Home page carousel' },
];

export const LayoutManagement = () => {
  const [tab, setTab] = useState('header');

  return (
    <div className="space-y-4" data-testid="layout-management">
      <div>
        <h2 className="text-xl font-semibold text-text_main">Layout</h2>
        <p className="text-sm text-text_muted mt-1">
          Structure and distribution of the site. Pages content lives in the <strong>Pages</strong> section — Layout only handles where pages appear.
        </p>
      </div>

      <div className="flex items-center gap-1 border-b border-border overflow-x-auto" data-testid="layout-tabs">
        {TABS.map(t => {
          const Icon = t.icon;
          const active = tab === t.key;
          return (
            <button
              key={t.key}
              type="button"
              onClick={() => setTab(t.key)}
              className={`inline-flex items-center gap-1.5 px-4 py-2.5 text-sm font-medium border-b-2 transition-colors ${
                active
                  ? 'text-primary border-primary'
                  : 'text-text_muted border-transparent hover:text-text_main'
              }`}
              data-testid={`layout-tab-${t.key}`}
            >
              <Icon size={15} weight={active ? 'bold' : 'regular'} />
              {t.label}
            </button>
          );
        })}
      </div>

      <div className="pt-2">
        {tab === 'header' && <HeaderNavManagement />}
        {tab === 'footer' && <FooterManagement />}
        {tab === 'banners' && <BannersManagement />}
      </div>
    </div>
  );
};
